import CommercialFreeholdField from './CommercialFreeholdField.component';

export default CommercialFreeholdField;
